import { Component, Input } from '@angular/core';
import { ControlContainer, FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CameraManageConfigVigilate } from '../../../models/Camera';

@Component({
  selector: 'app-vigilate-configs',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  viewProviders: [
    { provide: ControlContainer, useExisting: NgForm }
  ],
  templateUrl: './vigilate-configs.component.html',
  styleUrl: './vigilate-configs.component.scss'
})

export class VigilareConfigsComponent {
  showPassword = false;

  @Input()
  authConfig: CameraManageConfigVigilate = {};
}
